import { render, staticRenderFns } from "./editDataPrivilege.vue?vue&type=template&id=22358a45&scoped=true"
import script from "./editDataPrivilege.vue?vue&type=script&lang=js"
export * from "./editDataPrivilege.vue?vue&type=script&lang=js"
import style0 from "./editDataPrivilege.vue?vue&type=style&index=0&id=22358a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22358a45",
  null
  
)

export default component.exports